<form
  [formGroup]="documentUploadForm"
  [ngClass]="{ 'was-validated': submitted }"
  class="d-flex flex-column"
>
  <base-document-info
    *ngIf="documentUploadForm.controls.file.value"
    [documentControl]="documentUploadForm.controls.file"
    [errorMessage]="
      (documentUploadForm.controls.file.errors
        | baseFieldValidation
          : {
              fileSizeTooBig: 'fileSizeTooBigWithParams',
              fileTypeInvalid: 'fileTypeInvalid',
              fileTypePDF: 'fileTypePDF'
            }) || ''
    "
    (viewDocumentClicked)="viewDocument($event)"
    (deleteClicked)="deleteExistingFile()"
    class="mb-5"
  ></base-document-info>
  <base-document-upload
    *ngIf="!documentUploadForm.controls.file.value"
    [fileTypePlaceholder]="fileTypePlaceholder"
    [isInvalid]="!!documentUploadForm.controls.file.errors && submitted"
    [errorMessage]="documentUploadForm.controls.file.errors | baseFieldValidation: { required: 'file' }"
    formControlName="file"
    class="mb-5"
  ></base-document-upload>
  <div
    class="row mb-5"
    *ngIf="!hideNameInputField"
  >
    <div class="col-3">
      <label class="required fw-bold pt-2">{{ 'document.documentName' | translate }}</label>
    </div>
    <div class="col-9">
      <base-input
        [placeholder]="documentNameInputPlaceholder"
        [isInvalid]="!!documentUploadForm.controls.name.errors"
        [errorMessage]="documentUploadForm.controls.name.errors | baseFieldValidation"
        formControlName="name"
      ></base-input>
    </div>
  </div>
  <div
    class="row mb-5"
    *ngIf="!fixedCategory"
  >
    <div class="col-3 pt-2">
      <label class="required fw-bold">{{ 'category' | translate }}</label>
    </div>
    <div class="col-9">
      <base-dropdown
        [items]="documentCategories"
        formControlName="category"
        [searchable]="false"
        bindOptionLabel="label"
        placeholder="pleaseSelect"
        baseFieldValidationArgs="fileCategory"
      >
      </base-dropdown>
    </div>
  </div>
  <ng-container *ngIf="!hideExpirationDateSelection">
    <div class="row mb-2">
      <div class="col-3 d-flex align-items-center">
        <label class="required fw-bold">{{ 'dateTime.validUntil' | translate }}</label>
      </div>
      <div class="col-9">
        <base-datepicker
          formControlName="validUntil"
          [isInvalid]="!!documentUploadForm.controls.validUntil.errors"
          [errorText]="
            documentUploadForm.controls.validUntil.errors | baseFieldValidation: { required: 'validation.selectDate' }
          "
        ></base-datepicker>
      </div>
    </div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col-9">
        <base-checkbox
          label="dateTime.indefinitelyValid"
          [isChecked]="isValidIndefinitely"
          (getChange)="onValidIndefinitelyChange($event)"
        ></base-checkbox>
      </div>
    </div>
  </ng-container>
</form>

<ng-template #documentViewerTemplate>
  <base-document-viewer
    [src]="activeDocument"
    [fileName]="activeDocument.name"
    [fileType]="activeDocument.type"
    [modalRef]="documentViewerModalRef"
    (downloadImage)="downloadImage()"
  ></base-document-viewer>
</ng-template>
